import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Section from '../components/layout/Section';
import Button from '../components/ui/Button';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-20"> {/* Added pt-20 to account for fixed navbar */}
        <Section background="white">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-primary mb-6 mt-4">About Unique Solar Gardens Estate</h1>
            <p className="text-lg text-gray-700 mb-8">
              Unique Solar Gardens Estate is a visionary residential development committed to providing modern, sustainable, and comfortable living spaces. Located in the serene SHEGO District, KARU, our estate is designed to offer a unique blend of eco-friendly solutions and contemporary amenities.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Our core philosophy revolves around sustainability, which is why every home in our estate is powered by a dedicated mini-grid solar plant, ensuring 24/7 electricity and significantly reducing your carbon footprint. We believe in creating communities that thrive in harmony with nature, without compromising on modern conveniences.
            </p>
            <p className="text-lg text-gray-700 mb-10">
              Beyond reliable power, residents enjoy constant water supply, round-the-clock security, well-lit streets with solar street lights, and a quality road network with efficient drainage systems. Our commitment extends to efficient facility management and waste disposal, ensuring a clean and healthy environment for all.
            </p>
            <Button variant="primary" size="lg" onClick={() => window.location.href = '/contact'}>
              Contact Us
            </Button>
          </div>
        </Section>
        
        <Section background="light">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary mb-4">Our Vision</h2>
              <p className="text-gray-700 mb-6">
                To be the leading sustainable real estate developer, creating innovative and eco-friendly communities that set new standards for modern living.
              </p>
              <h2 className="text-3xl font-bold text-primary mb-4">Our Mission</h2>
              <p className="text-gray-700">
                To provide high-quality, solar-powered homes with reliable infrastructure, fostering a secure, comfortable, and environmentally conscious lifestyle for our residents.
              </p>
            </div>
            <div>
              <img 
                src="/assets/photos/14.jpg"
                alt="Our Vision" 
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
          </div>
        </Section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;